export default __webpack_public_path__ + "assets/find_parking.3d394644.png";